/* ah-restock-line.js — Impulse vintage v3 (robust toggle) */
(function() {
  function q(sel, root){ return (root||document).querySelector(sel); }

  // 1) 「売り切れ」判定（テーマ非依存）
  function isSoldOutByButton(root){
    // よくあるセレクタを順に探す
    var btn =
      q('form[action*="/cart/add"] [type="submit"][name="add"]', root) ||
      q('form[action="/cart/add"] [type="submit"][name="add"]', root) ||
      q('button[name="add"]', root) ||
      q('.product-form__submit', root);

    if (!btn) return null; // 判定不能

    var text = (btn.textContent || '').trim();
    var disabled =
      btn.disabled === true ||
      btn.getAttribute('aria-disabled') === 'true' ||
      btn.classList.contains('disabled');

    // 日本語テーマの「売り切れ」を含むかどうかも併用
    var looksSoldOut = /売り切れ|在庫切れ|SOLD\s?OUT/i.test(text);

    return disabled || looksSoldOut;
  }

  // 2) バリアントJSON（あれば使用）
  function safeParseJSON(text){
    if (!text || typeof text !== 'string') return null;
    var t = text.trim();
    if (!t || t.charAt(0) !== '{') return null;
    try { return JSON.parse(t); } catch(e){ return null; }
  }
  function getVariantFromTextarea(root){
    var ta = q('textarea[data-current-variant-json]', root);
    if (!ta) return null;
    return safeParseJSON(ta.value || ta.textContent || '');
  }
  function getVariantFromHidden(root){
    var idInput =
      q('form[action*="/cart/add"] input[name="id"]', root) ||
      q('form[action="/cart/add"] input[name="id"]', root) ||
      q('input[name="id"][type="hidden"]', root);
    if (!idInput) return null;

    var productIdAttr = q('#ah-restock-line-btn')?.getAttribute('data-product-id');
    if (!productIdAttr) return null;

    var el = document.getElementById('ah-restock-product-json-' + productIdAttr);
    var pd = el ? safeParseJSON(el.textContent || el.innerText || '') : null;
    if (!pd || !pd.variants) return null;

    var vid = String(idInput.value);
    for (var i=0;i<pd.variants.length;i++){
      if (String(pd.variants[i].id) === vid) return pd.variants[i];
    }
    return null;
  }

  function decideSoldOut(root){
    // まず見た目（ボタン）で判定
    var byBtn = isSoldOutByButton(root);
    if (byBtn !== null) return byBtn;

    // ボタンで判定できなければ、バリアントJSONで補完
    var v = getVariantFromTextarea(root) || getVariantFromHidden(root);
    if (v && typeof v.available === 'boolean') return v.available === false;

    // どれも拾えなければ「非売り切れ」と扱う（安全側）
    return false;
  }

  function toggle(){
    var btn = document.getElementById('ah-restock-line-btn');
    if (!btn) return;

    var root = btn.closest('.product-section') || document;
    var soldOut = decideSoldOut(root);

    btn.style.display = soldOut ? '' : 'none';
  }

  // 初期 & 遅延初期化対策
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      toggle();
      setTimeout(toggle, 120);
      setTimeout(toggle, 400);
    });
  } else {
    toggle();
    setTimeout(toggle, 120);
    setTimeout(toggle, 400);
  }

  // バリアント変更を広く拾う
  document.addEventListener('change', function(e){
    if (e.target && (e.target.name === 'id' || (e.target.name||'').indexOf('options[') === 0)) {
      toggle();
    }
  });
  document.addEventListener('variantChange', toggle);
  document.addEventListener('product:variant-change', toggle);

  // 監視：ボタンのdisabledやテキストが変われば反応
  var rootGuess = document.querySelector('.product-section') || document;
  var addBtn =
    q('form[action*="/cart/add"] [type="submit"][name="add"]', rootGuess) ||
    q('button[name="add"]', rootGuess) ||
    q('.product-form__submit', rootGuess);

  if (addBtn && 'MutationObserver' in window) {
    new MutationObserver(toggle).observe(addBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true
    });
  }

  // 監視：variant textareaの中身が変わる場合
  var ta = q('textarea[data-current-variant-json]', rootGuess);
  if (ta && 'MutationObserver' in window) {
    new MutationObserver(toggle).observe(ta, { characterData: true, subtree: true, childList: true });
  }
})();
